import axios from "../plugins/parseAxios";

export class OrderLogApi {
  static getOrderLogs(orderId) {
    return axios.post("functions/getOrderLogs", { orderId });
  }
}